// Curated lookbook — the 12 best antique-gold editorial photographs.
// Modern / CZ-style shots are intentionally excluded so every image reflects
// the house's antique gold, kundan, temple and jadau craft.
const lookbook = [
  { src: "/assets/lookbook/ms-017.jpg" }, // blue Banarasi, long antique haar
  { src: "/assets/lookbook/ms-131.jpg" }, // full bridal look, regal
  { src: "/assets/lookbook/ms-102.jpg" }, // red saree, long gold haram
  { src: "/assets/lookbook/ms-058.jpg" }, // kundan choker
  { src: "/assets/lookbook/ms-150.jpg" }, // temple haram + peacock pendant
  { src: "/assets/lookbook/ms-080.jpg" }, // white saree, kundan choker + long haar + jhumka
  { src: "/assets/lookbook/ms-103.jpg" }, // temple choker + long necklace
  { src: "/assets/lookbook/ms-039.jpg" }, // polki / jadau rani-haar
  { src: "/assets/lookbook/ms-085.jpg" }, // white saree, temple haar + jhumka
  { src: "/assets/lookbook/ms-151.jpg" }, // blue saree, direct gaze
  { src: "/assets/lookbook/ms-030.jpg" }, // white saree, palace corridor
  { src: "/assets/lookbook/ms-145.jpg" }, // red saree, long haar (detail)
];

export default lookbook;
